import { useEffect } from 'react'

import {
  getVariantPropertiesForExperiment,
  initializeBackendABTesting,
} from '@core/abTesting/backend/backendABTesting'
import { getGlobalConfig } from '@core/globalConfig'
import { useStore } from '@core/widgets/store'
import {
  appContextSelector,
  paramsSelector,
} from '@core/widgets/store/selectors'

import { WIDGET_EXPERIMENTS } from './experiments'

/**
 * Loads backend A/B testing experiments and merges their
 * variant_properties into the widget params store.
 * Experiments always require business_id. ExpPlat also sends channel_id
 * once the channel resolves.
 */
export const WidgetExperiments: React.FunctionComponent<
  React.PropsWithChildren
> = ({ children }) => {
  const actions = useStore((state) => state.actions)
  const params = useStore(paramsSelector)
  const appContext = useStore(appContextSelector)
  const businessId =
    params.business_id ||
    appContext?.channel?.business_id ||
    getGlobalConfig().business_id
  const channelId =
    params.channel_id ||
    appContext?.channel?.encoded_id ||
    appContext?.channelId

  useEffect(() => {
    if (!businessId) {
      return
    }

    initializeBackendABTesting({
      business_id: businessId,
      ...(channelId ? { channel_id: channelId } : {}),
    }).then(() => {
      const merged: Record<string, string> = {}
      for (const experimentType of WIDGET_EXPERIMENTS) {
        const props = getVariantPropertiesForExperiment(experimentType)
        if (props) {
          Object.assign(merged, props)
        }
      }
      if (Object.keys(merged).length > 0) {
        actions.setExperimentParams(merged)
      }
    })
  }, [actions, businessId, channelId])

  return <>{children}</>
}
